// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*,:after,:before{box-sizing:border-box}body{background-color:var(--body-background)}body.scroll-locked{overflow:hidden}body,button,select{font-family:\"Red Hat Text\",sans-serif}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
